/* global mixpanel */

export const IDENTIFY = "IDENTIFY";
export const PEOPLE = "PEOPLE";
export const PEOPLE_APPEND = "PEOPLE_APPEND";
export const PEOPLE_INCREMENT = "PEOPLE_INCREMENT";

export const TRACK_OPEN = "Open Settings Webview";
export const TRACK_ADD_HOUR = "Settings Webview Add Hour";
export const TRACK_EDIT_HOUR = "Settings Webview Edit Hour";
export const TRACK_DELETE_HOUR = "Settings Webview Delete Hour";
export const TRACK_EDIT_DAYS = "Settings Webview Edit Days";
export const TRACK_EDIT_TIMEZONE = "Settings Webview Edit Timezone";

const EVENTS = {
  [TRACK_OPEN]: true,
  [TRACK_ADD_HOUR]: true,
  [TRACK_EDIT_HOUR]: true,
  [TRACK_DELETE_HOUR]: true,
  [TRACK_EDIT_DAYS]: true,
  [TRACK_EDIT_TIMEZONE]: true
};

export const callOnlyOnce = fn => {
  let called = false;
  return (...args) => {
    if (!called) {
      called = true;
      return fn(...args);
    }
  };
};

export default () => {
  let identified = false;
  return next => ({ type, payload }) => {
    const warn = () =>
      !identified &&
      console.warn(
        "Trying to track event but no user was identified \n e.g. dispatch({ type: 'IDENTIFY', payload: '<psid>' })"
      );

    if (type === IDENTIFY) {
      mixpanel.identify(payload);
      identified = true;
    } else if (type === PEOPLE) {
      warn();
      mixpanel.people.set(payload);
    } else if (type === PEOPLE_INCREMENT) {
      warn();
      mixpanel.people.increment(payload);
    } else if (type === PEOPLE_APPEND) {
      warn();
      mixpanel.people.append.apply(mixpanel.people, payload);
    } else if (EVENTS[type]) {
      warn();
      mixpanel.track(type, payload || {});
    }

    return next({ type, payload });
  };
};



// WEBPACK FOOTER //
// ./src/store/mixpanel.js